import classNames from 'classnames';
import React, { PropTypes, PureComponent } from 'react';
import { withStyle } from '../../utils/Decorator';

@withStyle(require('./Spinner.styl'))
export default class Spinner extends PureComponent {
  static propTypes = {
    white: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    white: false,
  };

  render = () => (
    <div className={classNames('Spinner', { white: this.props.white })}>
      <div className='SpinnerCircle1 SpinnerCircle' />
      <div className='SpinnerCircle2 SpinnerCircle' />
      <div className='SpinnerCircle3 SpinnerCircle' />
      <div className='SpinnerCircle4 SpinnerCircle' />
      <div className='SpinnerCircle5 SpinnerCircle' />
      <div className='SpinnerCircle6 SpinnerCircle' />
      <div className='SpinnerCircle7 SpinnerCircle' />
      <div className='SpinnerCircle8 SpinnerCircle' />
      <div className='SpinnerCircle9 SpinnerCircle' />
      <div className='SpinnerCircle10 SpinnerCircle' />
      <div className='SpinnerCircle11 SpinnerCircle' />
      <div className='SpinnerCircle12 SpinnerCircle' />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/components/Spinner/Spinner.jsx